import { render } from "./ResourcesSection.vue?vue&type=template&id=5ae892e0"
import script from "./ResourcesSection.vue?vue&type=script&lang=js"
export * from "./ResourcesSection.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__